import Joi from '@hapi/joi'

export const FactoryWeightPointFilteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity required`,
        "any.required": `Operatin Entity required`
    }),
    collectionCatagoryID: Joi.number().invalid(0).required().label("Collection Catagory").messages({
        "any.invalid": `Collection Catagory required`,
        "any.required": `Collection Catagory required`
    })
}

export const FactoryWeightPointAddEditSchema = {
    groupID:  Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID:Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity Required`,
        "any.required": `Operatin Entity Required`
    }),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collection Catagory").messages({
        "any.invalid": `Collection Catagory required`,
        "any.required": `Collection Catagory required`
    }),
    collectionPointCode: Joi.string().required().label("Code").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Code required`,
        "string.pattern.base": `Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`,
        "any.invalid": `Cannot have 00 as Code`
    }),
    collectionPointName: Joi.string().required().label("Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Name required`,
        "string.pattern.base": `Please enter valid Name`,
    }),

    collectionPointLocation: Joi.string().allow("", null).label("Location"),
    isActive: Joi.boolean().label("Active"),
}